import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import UsersTableColumns from '../containers/UsersTableColumns';

const UsersTableHeader = ({
  category,
  children,
  columns,
  hideColumns,
  loaderButton,
  readErrors,
  readStatus,
  users,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    {!hideColumns && <UsersTableColumns category={category} items={users} columns={columns} />}
  </Table.Header>
);

export default UsersTableHeader;
